"use client";

import { clsx } from "clsx";
import { ProductCard } from "./product-card";
import type { ProductGridProps } from "@/types/product";

export function ProductGrid({
  items,
  loading = false,
  showFavorite = false,
  onFavoriteToggle,
  className
}: ProductGridProps) {
  if (loading) {
    return (
      <div className={clsx(
        "grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6",
        className
      )}>
        {Array.from({ length: 8 }).map((_, index) => (
          <ProductCardSkeleton key={index} />
        ))}
      </div>
    );
  }

  if (items.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-12 text-center">
        <div className="w-16 h-16 bg-muted rounded-lg flex items-center justify-center mb-4">
          <div className="w-8 h-8 bg-muted-foreground/20 rounded" />
        </div>
        <h3 className="text-lg font-semibold text-foreground mb-2">
          상품이 없습니다
        </h3>
        <p className="text-muted-foreground max-w-md">
          현재 조건에 맞는 특산물이 없습니다. 다른 조건으로 검색해보세요.
        </p>
      </div>
    );
  }

  return (
    <div className={clsx(
      "grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6",
      className
    )}>
      {items.map((item) => (
        <ProductCard
          key={item.id}
          item={item}
          showFavorite={showFavorite}
          onFavoriteToggle={onFavoriteToggle}
        />
      ))}
    </div>
  );
}

function ProductCardSkeleton() {
  return (
    <div className="bg-card border rounded-lg overflow-hidden animate-pulse">
      {/* 이미지 스켈레톤 */}
      <div className="aspect-[4/3] bg-muted" />
      
      {/* 콘텐츠 스켈레톤 */}
      <div className="p-4 space-y-3">
        {/* 제목 스켈레톤 */}
        <div className="space-y-2">
          <div className="h-4 bg-muted rounded w-3/4" />
          <div className="h-3 bg-muted rounded w-1/2" />
        </div>
        
        {/* 평점 스켈레톤 */}
        <div className="h-4 bg-muted rounded w-1/3" />
        
        {/* 가격 스켈레톤 */}
        <div className="h-5 bg-muted rounded w-1/2" />
        
        {/* 설명 스켈레톤 */}
        <div className="space-y-2">
          <div className="h-3 bg-muted rounded w-full" />
          <div className="h-3 bg-muted rounded w-2/3" />
        </div>
        
        {/* 구분선 */}
        <div className="h-px bg-muted my-3" />
        
        {/* 버튼 스켈레톤 */}
        <div className="flex gap-2">
          <div className="flex-1 h-8 bg-muted rounded" />
          <div className="flex-1 h-8 bg-muted rounded" />
        </div>
      </div>
    </div>
  );
}

export { ProductCardSkeleton };